// Placeholder Help System - Maps each placeholder to its CRM location

export interface PlaceholderHelpInfo {
  location: string;        // Short description of where to find it
  path: string;           // Full navigation path in the app
  field: string;          // Field name in the form
  navPath?: string;       // Route path for navigation
}

export const placeholderHelpMap: Record<string, PlaceholderHelpInfo> = {
  // ===== EIGEN BEDRIJF - Via CRM Instellingen =====
  '{{company_logo}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Bedrijfslogo (upload sectie)',
    navPath: '/crm/settings'
  },
  '{{company_name}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Bedrijfsnaam',
    navPath: '/crm/settings'
  },
  '{{company_street}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Straat + Huisnummer',
    navPath: '/crm/settings'
  },
  '{{company_postal_code}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Postcode',
    navPath: '/crm/settings'
  },
  '{{company_city}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Plaats',
    navPath: '/crm/settings'
  },
  '{{company_country}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Land',
    navPath: '/crm/settings'
  },
  '{{company_full_address}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Samengesteld uit: Straat, Huisnummer, Postcode, Plaats',
    navPath: '/crm/settings'
  },
  '{{company_kvk}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'KvK nummer',
    navPath: '/crm/settings'
  },
  '{{company_btw}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'BTW nummer',
    navPath: '/crm/settings'
  },
  '{{company_iban}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'IBAN',
    navPath: '/crm/settings'
  },
  '{{company_bic}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'BIC/SWIFT code',
    navPath: '/crm/settings'
  },
  '{{company_phone}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Telefoonnummer',
    navPath: '/crm/settings'
  },
  '{{company_email}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'E-mailadres',
    navPath: '/crm/settings'
  },
  '{{company_website}}': {
    location: 'CRM Instellingen',
    path: 'CRM → Instellingen → Bedrijfsgegevens',
    field: 'Website',
    navPath: '/crm/settings'
  },

  // ===== KLANT ORGANISATIE - Via Organisaties module =====
  '{{organization_name}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Bewerken',
    field: 'Naam',
    navPath: '/crm/organizations'
  },
  '{{organization_kvk}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Bewerken',
    field: 'KVK nummer',
    navPath: '/crm/organizations'
  },
  '{{organization_btw}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Bewerken',
    field: 'BTW nummer',
    navPath: '/crm/organizations'
  },
  '{{organization_street}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Adressen tab',
    field: 'Straat + Huisnummer',
    navPath: '/crm/organizations'
  },
  '{{organization_postal_code}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Adressen tab',
    field: 'Postcode',
    navPath: '/crm/organizations'
  },
  '{{organization_city}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Adressen tab',
    field: 'Plaats',
    navPath: '/crm/organizations'
  },
  '{{organization_country}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Adressen tab',
    field: 'Land',
    navPath: '/crm/organizations'
  },
  '{{organization_full_address}}': {
    location: 'Organisaties',
    path: 'CRM → Organisaties → [Selecteer organisatie] → Adressen tab',
    field: 'Samengesteld uit alle adresvelden',
    navPath: '/crm/organizations'
  },

  // ===== CONTACTPERSOON - Via Contacten module =====
  '{{contact_name}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Voornaam + Achternaam (gecombineerd)',
    navPath: '/crm/contacts'
  },
  '{{contact_first_name}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Voornaam',
    navPath: '/crm/contacts'
  },
  '{{contact_last_name}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Achternaam',
    navPath: '/crm/contacts'
  },
  '{{contact_email}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'E-mailadres',
    navPath: '/crm/contacts'
  },
  '{{contact_phone}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Telefoon',
    navPath: '/crm/contacts'
  },
  '{{contact_mobile}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Mobiel',
    navPath: '/crm/contacts'
  },
  '{{contact_function}}': {
    location: 'Contacten',
    path: 'CRM → Contacten → [Selecteer contact] → Bewerken',
    field: 'Functie',
    navPath: '/crm/contacts'
  },

  // ===== OFFERTE VELDEN - Via Offerte detail pagina =====
  '{{quote_number}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte]',
    field: 'Automatisch gegenereerd offertenummer (Q-XXXXX)',
  },
  '{{quote_title}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Header',
    field: 'Titel',
  },
  '{{quote_date}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte]',
    field: 'Aanmaakdatum (automatisch)',
  },
  '{{valid_until}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Header',
    field: 'Geldig tot',
  },
  '{{reference}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Klantgegevens sectie',
    field: 'Uw referentie/kenmerk',
  },
  '{{version_number}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte]',
    field: 'Versienummer (automatisch bij "Nieuwe versie")',
  },

  // ===== FINANCIEEL - Via Offerte regelitems =====
  '{{subtotal}}': {
    location: 'Offerte Regelitems',
    path: 'CRM → Offertes → [Open offerte] → Regelitems sectie',
    field: 'Berekend subtotaal (som van regelitems excl. BTW)',
  },
  '{{vat_amount}}': {
    location: 'Offerte Regelitems',
    path: 'CRM → Offertes → [Open offerte] → Regelitems sectie',
    field: 'Berekend BTW bedrag',
  },
  '{{vat_rate}}': {
    location: 'Offerte Regelitems',
    path: 'CRM → Offertes → [Open offerte] → Regelitems sectie',
    field: 'BTW percentage per regelitem (standaard 21%)',
  },
  '{{total}}': {
    location: 'Offerte Regelitems',
    path: 'CRM → Offertes → [Open offerte] → Regelitems sectie',
    field: 'Berekend totaalbedrag inclusief BTW',
  },
  '{{discount_amount}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Klantgegevens sectie',
    field: 'Korting (EUR)',
  },
  '{{discount_percentage}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Klantgegevens sectie',
    field: 'Korting (%)',
  },
  '{{payment_term}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Klantgegevens sectie',
    field: 'Betalingstermijn (dagen)',
  },
  '{{payment_due_date}}': {
    location: 'Systeem',
    path: 'Automatisch berekend',
    field: 'Huidige datum + betalingstermijn',
  },

  // ===== PROJECT =====
  '{{project_name}}': {
    location: 'Projecten',
    path: 'Projecten → [Selecteer project]',
    field: 'Projectnaam',
    navPath: '/projecten'
  },
  '{{project_number}}': {
    location: 'Projecten',
    path: 'Projecten → [Selecteer project]',
    field: 'Projectnummer',
    navPath: '/projecten'
  },

  // ===== AANVULLENDE VOORWAARDEN =====
  '{{additional_conditions}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte] → Aanvullende voorwaarden',
    field: 'Aanvullende voorwaarden tekstveld',
  },

  // ===== REGELITEMS TABEL =====
  '{{line_items_table}}': {
    location: 'Offerte Regelitems',
    path: 'CRM → Offertes → [Open offerte] → Regelitems sectie',
    field: 'Alle regelitems worden automatisch als tabel weergegeven',
  },

  // ===== OVERIG =====
  '{{current_date}}': {
    location: 'Systeem',
    path: 'Automatisch',
    field: 'Huidige datum op moment van PDF generatie',
  },
  '{{owner_name}}': {
    location: 'Offerte',
    path: 'CRM → Offertes → [Open offerte]',
    field: 'Aangemaakt door (jouw gebruikersnaam)',
  },
};

export const getPlaceholderHelp = (key: string): PlaceholderHelpInfo | null => {
  return placeholderHelpMap[key] || null;
};
